export default {

  required: {
    message : "Please fill the Bonus Code!",
    fn      : (input)=>  Boolean(input)
  },

  format: {
    message : "Wrong format for the Bonus Code!",
    fn      : (input)=>  !input.includes('/')
  },

}
